import React, { useEffect, useState } from 'react';
import { BlockPicker, ColorResult } from 'react-color';
import styled from 'styled-components';
import { RoutalText } from './RoutalText';

import { RoutalDefaultColors } from './Colors';

type ColorSampleProps = {
  color?: string;
  disabled?: boolean;
};

export const ColorSample = styled.div`
  height: 22px;
  width: 22px;
  ${(props: ColorSampleProps) => `background-color: ${props.color ? props.color : `transparent`};`}
  border-radius: 50%;
  cursor: ${(props: ColorSampleProps) => (props.disabled ? `default` : `pointer`)};

  ${(props: ColorSampleProps) =>
    props.disabled
      ? `
    opacity: 0.5;
    cursor: default;
  `
      : `
    opacity: 1;
    cursor: pointer;
  `}

  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;

  ${(props: ColorSampleProps) => {
    if (!props.color) {
      return `
      border: 1px solid rgb(170, 170, 170);

      // THIS IS A TEST -> TRY TO SIMULATE AN EMPTY ICON.
      // position: relative;
      // &:after {
      //   position: absolute;
      //   left: 7px;
      //   top: -4px;
      //   content: '/';
      //   width: auto;
      //   height: auto;
      //   color: #ffa6a6;
      //   font-size: 23px;
      // }`;
    }
    return ``;
  }}
`;

type RoutalColorPickerPickerProps = {
  disabled?: boolean;
  color?: string;
  label?: string | React.ReactElement;
  presetColors?: string[];
  onUpdate: (hex: string) => void;
  colorSampleContent?: React.ReactElement;
  colorSampleStyles?: React.CSSProperties;
  containerStyles?: React.CSSProperties;
};

export const RoutalColorPicker = ({
  disabled = false,
  color = RoutalDefaultColors[0],
  label,
  presetColors = RoutalDefaultColors,
  onUpdate,
  colorSampleContent,
  colorSampleStyles = {},
  containerStyles = {},
}: RoutalColorPickerPickerProps) => {
  const [currentColor, setCurrentColor] = useState<string | undefined>();
  const [showColorPicker, setShowColorPicker] = useState<boolean>(false);

  useEffect(() => {
    if (color) {
      setCurrentColor(color);
    }
  }, [color]);

  const handleColorChange = ({ hex }: ColorResult) => {
    onUpdate(hex);
    setShowColorPicker(false);
  };

  return (
    <>
      {label && <RoutalText variant="label">{label}</RoutalText>}

      <div style={{ position: `relative`, ...containerStyles }}>
        <ColorSample
          disabled={disabled}
          style={{ ...colorSampleStyles }}
          onClick={() => {
            if (!disabled) {
              setShowColorPicker(!showColorPicker);
            }
          }}
          color={currentColor}
        >
          {colorSampleContent}
        </ColorSample>

        {showColorPicker ? (
          <div
            style={{
              position: `absolute`,
              top: `100%`,
              left: `50%`,
              transform: `translateX(-50%)`,
              marginTop: 15,
              zIndex: 2,
              boxShadow: `rgba(0, 0, 0, 0.16) 0px 3px 6px, rgba(0, 0, 0, 0.23) 0px 3px 6px`,
              borderRadius: `6px`,
            }}
          >
            <BlockPicker color={currentColor} colors={presetColors || []} onChangeComplete={handleColorChange} />
          </div>
        ) : null}
      </div>
    </>
  );
};
